module.exports = __webpack_public_path__ + "static/media/enter.61f42d31.ico";